export default 'auditLogs.filters';
